import { Injectable } from '@angular/core';

export interface ListState {
  pageIndex: number;
  pageSize: number;
  sortQuery: string;
  filterCriteria: any[];
  activeView: boolean;
}

/**
 * Singleton service that caches list pagination / filter / sort state
 * per route key (speaker.model). State survives component destruction
 * so navigating away from a list and back restores the user's position.
 *
 * Call `clear(key)` on explicit reset; call `clearAll()` on logout.
 */
@Injectable({ providedIn: 'root' })
export class ListStateService {
  private cache = new Map<string, ListState>();

  /** Persist current list state for a route key. */
  save(key: string, state: ListState): void {
    this.cache.set(key, { ...state, filterCriteria: [...state.filterCriteria] });
  }

  /** Retrieve cached state, or null if none exists. */
  restore(key: string): ListState | null {
    const s = this.cache.get(key);
    return s ? { ...s, filterCriteria: [...s.filterCriteria] } : null;
  }

  /** Clear state for a single route (e.g. on Reset Filters). */
  clear(key: string): void {
    this.cache.delete(key);
  }

  /** Clear all cached state (e.g. on logout). */
  clearAll(): void {
    this.cache.clear();
  }
}
